import React, { useCallback, useState } from 'react';
import PropTypes from 'prop-types';
import { orderBy } from 'lodash';
export const QuickLinksContext = React.createContext({
    links: [],
    count: 0,
    setLinks: () => null,
    setLinksCount: () => null,
});
export const quickLinksContextPropTypes = {
    links: PropTypes.arrayOf(PropTypes.shape({
        id: PropTypes.number,
        url: PropTypes.string,
        name: PropTypes.string,
        description: PropTypes.string,
        sequence: PropTypes.number,
    })),
    setLinks: PropTypes.func,
    setLinksCount: PropTypes.func,
    count: PropTypes.number,
};
const QuickLinksContextProvider = ({ children }) => {
    const [quickLinks, setQuickLinks] = useState([]);
    const [quickLinksCount, setQuickLinksCount] = useState(0);
    const setLinks = useCallback((links) => {
        setQuickLinks(orderBy(links, 'sequence'));
    }, []);
    const setLinksCount = useCallback((count) => {
        setQuickLinksCount(count);
    }, []);
    return (<QuickLinksContext.Provider value={{
        links: quickLinks,
        setLinks,
        count: quickLinksCount,
        setLinksCount,
    }}>
      {children}
    </QuickLinksContext.Provider>);
};
export default QuickLinksContextProvider;
